<form [formGroup]="sgke072aRequestForm">
    <mat-card class="cur-card">
        <mat-card-header>
            <mat-card-title>充当登録</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-card
                    class="mat-elevation-z0 grp-card tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[66%]">
                    <mat-card-header>
                        <mat-card-subtitle>充当先情報</mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content class="tw-flex tw-flex-row tw-flex-wrap">
                        <mat-form-field appearance="fill"
                            class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-w-[45%]">
                            <mat-label>支払方法</mat-label>
                            <input matInput id="payMethod" readonly="true" value="{{gamenHyojiInfo?.payMethod.aname}}"
                                class="font-color-display-only" disabled>
                        </mat-form-field>
                        <mat-form-field appearance="fill"
                            class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-w-[45%]">
                            <mat-label>次回請求予定日</mat-label>
                            <input matInput id="jikaiClaimPlndate" value="{{jikaiClaimPlndate | date : 'yyyy/MM/dd'}}"
                                class="font-color-display-only" disabled>
                        </mat-form-field>
                    </mat-card-content>
                </mat-card>
            </div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
                <mat-card-actions class="btn_area_right">
                    <button type="submit" [disabled]="kinkoStatuscode == '03'" (click)="onClickApprovalReq(true)"
                        mat-raised-button color="primary" class="btn">充当確定</button>
                    <button type="submit" [disabled]="kinkoStatuscode != '03'" (click)="onClickApprovalReq(false)"
                        mat-raised-button color="primary" class="btn">充当解除</button>
                </mat-card-actions>
            </div>
        </mat-card-content>
    </mat-card>
</form>